import api from './api';

/*
 * API client for SURPRISE GIFTS — the "add a wish ON BEHALF of another member,
 * hidden from them" flow. The OPPOSITE of suggestions (services/suggestions.js):
 * a suggestion is consensual and recipient-aware; a surprise gift must never
 * reach the recipient at all.
 *
 * A group member adds a wish for another member. The backend sets
 * `user_id = recipient` (so all gifting/claim/purchase logic works unchanged),
 * `suggested_by_user_id = the actor`, and `hidden_from_owner = true`. A global
 * query scope on the API then removes the wish from EVERY result set the
 * recipient's client could see (list, feed, counts, events, search,
 * notifications) — so the client does NOT hide it; the recipient simply never
 * receives it. Full design: ../listful-api/docs/FEEDBACK_PLAN.md §5.
 *
 * Endpoint (auth:sanctum, /api/v1):
 *   POST /surprise-gifts  → 201, the created wish (owned by the recipient) with
 *                           `suggested_by_user_id`, `hidden_from_owner: true`,
 *                           and loaded `suggested_by`, `category`, `groups`.
 *
 * Errors follow the envelope's `error` string:
 *   422 — recipient is yourself, or not a member of the chosen group.
 *   403 — you are not a member of the chosen group.
 *
 * Returns the already-unwrapped payload: the shared axios instance
 * (services/api.js) strips the { success, data, ... } envelope, so `res.data`
 * here is the plain wish the controller returned. Mirrors services/people.js.
 */

// POST /surprise-gifts — add a surprise wish for another member. `payload` =
// { recipient_user_id, group_id, title, description?, url?, image_url?,
//   price_min?, price_max?, priority?, category_id? }. Returns the created wish.
export async function createSurpriseGift(payload) {
    const res = await api.post('/surprise-gifts', payload);
    return res.data;
}
